import api from '../services/api'
import util from '@/helpers/util';

export default {
    namespaced: true,
    state: {
        venomTypesLoading: false,
        venomTypesLoadError: "",
        venomTypesSaving: false,
        venomTypesSaveError: "",
        venomTypes: [],
    },
  
    getters: {
        loading(state) {
            return state.venomTypesLoading
        },
        activeVenomTypes(state) {
            return state.venomTypes
                .filter(x => x.Active)
                .sort(util.sortByField("VenomTypeName"));
        }
    },
  
    mutations: {
        clearSaveErrors(state) {
            state.venomTypesSaveError = "";
        },
        loading(state) {
            state.venomTypesLoading = true;
            state.venomTypesLoadError = "";
        },
        loadComplete(state) {
            state.venomTypesLoading = false;
        },
        loadError(state, data) {
            state.venomTypes = [];
            state.venomTypesLoadError = data.error;
        },
        saving(state) {
            state.venomTypesSaving = true;
            state.venomTypesSaveError = "";
        },
        saveComplete(state) {
            state.venomTypesSaving = false;
        },
        saveError(state, data) {
            state.venomTypesSaveError = data.error;
        },
        clearSaveError(state) {
            state.venomTypesSaveError =  "";
        },
        setVenomTypes(state, data) {
            state.venomTypes = data;
        }
    },
  
    actions: {
        clearSaveErrors(context) {
            context.commit("clearSaveErrors");
        },
        
        saveVenomType(context, options) {
            context.commit("saving");

            api.saveVenomType(
                options.venomType,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of location (which will include the changes we requested)
                        context.commit("setVenomTypes", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", {error: api.parseHttpRequestError(e)});

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },

        loadVenomTypes(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading");

                api.fetchVenomTypes({
                    success: function(response) {
                        context.commit("setVenomTypes", response.data);
                        resolve();
                    },
                    error: function(e) {
                        context.commit("loadError", {error: api.parseHttpRequestError(e)});
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function() {
                        context.commit("loadComplete");
                    }
                });
            });
        },
    }
}